var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentType[_vm.curStatus],{ref:"fromRef",tag:"component",staticClass:"mt-20 container",attrs:{"pdfFile":_vm.pdfFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }